import { reactive } from "vue";
export default function useFormStylingLogic() {
  const actions = reactive({
    addProject: true,
    addImages: false,
    imagesChosen: false,
    addClient: false,
    changeCoverImage: false
  });

  const coverImgButtons = reactive({
    firstBtn: null,
    secondBtn: null
  });

  const coverImgStyle = reactive({
    size: "small",
    radius: "half",
    btnOpacity: "transparent"
  });

  const coverImgContent = reactive({
    title: "Project Information",
    text: null,
    icon: null
  });

  function setCoverImgButtons(firstBtnText, secondBtnText) {
    if (firstBtnText !== "") coverImgButtons.firstBtn = firstBtnText;
    if (secondBtnText !== "") coverImgButtons.secondBtn = secondBtnText;
  }

  function setCoverImgStyle(size, radius, opacity) {
    if (size) coverImgStyle.size = size;
    if (radius) coverImgStyle.radius = radius;
    if (opacity) coverImgStyle.btnOpacity = opacity;
  }

  function setCoverImgContent(title, text, icon) {
    if (title) coverImgContent.title = title;
    coverImgContent.text = text;
    if (icon) coverImgContent.icon = icon;
  }

  function addImages(mobile) {
    //actions.addProject = false;
    actions.addImages = true;
    setCoverImgButtons(null, "");
    setCoverImgContent(null, "Choose images to upload", "pi-images");
    if (mobile) setCoverImgStyle("small", "half");
    else setCoverImgStyle(null, "half");
  }

  function addClient() {
    actions.addClient = true;
    setCoverImgButtons(null, "");
    setCoverImgStyle("small", "half");
    setCoverImgContent("Client Information", "", null);
  }

  function changeCoverImage(mobile) {
    actions.changeCoverImage = true;
    if (mobile) setCoverImgStyle("small", "half");
    else setCoverImgStyle(null, "half");
    setCoverImgContent(null, "Choose a cover image", "pi-images");
    setCoverImgButtons("Back to default image", "");
  }

  function imagesChosen() {
    setCoverImgStyle("small", null);
    actions.imagesChosen = true;
  }

  function imagesCleared(mobile) {
    actions.imagesChosen = false;
    if (mobile) setCoverImgStyle("small", null);
    else setCoverImgStyle("large", null);
  }

  function changeContentStyle(content, height, padding) {
    if (height) content.value.style.height = height;
    if (padding) content.value.style.padding = padding;
  }

  return {
    coverImgButtons,
    setCoverImgButtons,
    coverImgStyle,
    setCoverImgStyle,
    coverImgContent,
    setCoverImgContent,
    actions,
    addImages,
    addClient,
    imagesChosen,
    imagesCleared,
    changeCoverImage,
    changeContentStyle
  };
}
